import LayoutField from 'component/element/workdoc/layout/form-layout'
import EMSelect from './EMSelect'
import EMDatePicker from './EMDatePicker'
import EMCheckbox from './EMCheckbox'
import EMRadio from './EMRadio'
import EMInput from './EMInput'
import InputNumber from 'component/element/InputNumber'
export const DEFAULT_SCHEMA = {
    group1: {
        title: '',
        type: 'object',
        required: ['first_name','last_name','nick_name','mobile','address_registration','current_address','gender','religion','race','nationality','marriage_status'],
        properties: {
            employee_id: {type: 'string', title: 'รหัสพนักงาน', default: ''},
            title: {type: 'string', title: 'คำนำหน้าชื่อ', default: 'นาย'},
            first_name: {type: 'string', title: 'ชื่อ', default: ''},
            last_name: {type: 'string', title: 'นามสกุล', default: ''},
            nick_name: {type: 'string', title: 'ชื่อเล่น', default: ''},
            mobile: {type: 'string', title: 'มือถือ', default: ''},
            address_registration: {type: 'string', title: 'ทะเบียนบ้าน', default: ''},
            current_address: {type: 'string', title: 'ที่อยู่ปัจจุบัน', default: ''},
            gender: {type: 'string', title: 'เพศ', default: 'male'},
            religion: {type: 'string', title: 'ศาสนา', default: 'พุทธ'},
            race: {type: 'string', title: 'เชื้อชาติ', default: ''},
            nationality: {type: 'string', title: 'สัญชาติ', default: ''},
            height: {type: 'string', title: 'ส่วนสูง', default: ''},
            weight: {type: 'string', title: 'นำ้หนัก', default: ''},
            marriage_status: {type: 'string', title: 'สถานะ', default: 'โสด'},
            children: {type: 'string', title: 'จำนวนบุตร', default: ''}
        }    
    },
    group2: {
        title: '',
        type: 'object',
        required: ['dob_date','id_card','no_taxpayer'],
        properties: {
            dob_date: {type: 'string', title: 'วันเดือนปีเกิด', default: ''},
            id_card: {type: 'string', title: 'บัตรประชาชน', default: ''},
            ssn: {type: 'string', title: 'เลขที่ประกันสังคม', default: ''},
            no_taxpayer: {type: 'string', title: 'เลขที่ผู้เสียภาษี', default: ''},
            bank_name: {type: 'string', title: 'ธนาคาร', default: ''},
            bank_account: {type: 'string', title: 'เลขที่บัญชี', default: ''}
        }
    },
    group3: {
        title: '',
        type: 'object',
        required: ['start_work_date','permanance_work_date','position','department','work_status'],
        properties: {
            start_work_date: {type: 'string', title: 'เริ่มทำงาน', default: ''},
            permanance_work_date: {type: 'string', title: 'บรรจุเป็นพนักงาน', default: ''},
            position: {type: 'string', title: 'ตำแหน่ง', default: ''},
            department: {type: 'string', title: 'แผนก', default: ''},
            work_status: {type: 'string', title: 'สถานะการทำงาน', default: ''},
            slip_per_month: {type: 'string', title: 'ออกสลิป', default: '1'},
            exit_date: {type: 'string', title: 'ลาออกวันที่', default: ''},
            exit_reason: {type: 'string', title: 'เหตุที่ออก', default: ''},
            exit_remark: {type: 'string', title: 'หมายเหตุ', default: ''}
        }
    },
    group4: {
        title: '',
        type: 'object',
        required: [],
        properties: {
            sick_quota: {type: 'string', title: 'ป่วย', default: ''},
            business_quota: {type: 'string', title: 'ลากิจ', default: ''}
        }
    },
    group5: {
        title: '',
        type: 'object',
        required: [],
        properties: {
            net_saving: {type: 'string', title: 'เงินสะสม(ปัจจุบัน)', default: ''}
        }
    },
    group6: {
        title: '',
        type: 'object',
        required: [],
        properties: {
            perm_taking_car: {type: 'boolean', title: 'รับ/ส่งมอบรถ', default: false},
            perm_job_owner: {type: 'boolean', title: 'รับผิดชอบใบงาน/จ็อบ', default: false},
            perm_taking_stock: {type: 'boolean', title: 'อนุมัติเครื่องมือ/อะไหล่', default: false},
            perm_fixing_car: {type: 'boolean', title: 'ช่างซ่อม', default: false},
            perm_checking_car: {type: 'boolean', title: 'ช่างผู้ตรวจสอบ', default: false}
        }
    },
    group7: {
        title: '',
        type: 'object',
        required: [],
        properties: {
            slip_by: {type: 'string', title: 'ผู้ออกสลิปเงินเดือน', default: 'hr'}
        }
    }       
}

export const DEFAULT_UI_SCHEMA = {
    group1: {
        'ui:field': LayoutField,
        'ui:layout': [
            [
                {name: 'title', props: {md: 2}},
                {name: 'first_name', props: {md: 4}},
                {name: 'last_name', props: {md: 6}}
            ],
            [
                {name: 'nick_name', props: {md: 6}},
                {name: 'mobile', props: {md: 6}}
            ],
            [
                {name: 'address_registration', props: {md: 12}}
            ],
            [
                {name: 'current_address', props: {md: 12}}
            ],
            [
                {name: 'gender', props: {md: 3}},
                {name: 'religion', props: {md: 3}},
                {name: 'race', props: {md: 3}},
                {name: 'nationality', props: {md: 3}}
            ],
            [
                {name: 'height', props: {md: 3}},
                {name: 'weight', props: {md: 3}},
                {name: 'marriage_status', props: {md: 3}},
                {name: 'children', props: {md: 3}}
            ]    
        ],
        title: {'ui:field': EMSelect, 'options': [{label:'นาย',value:'นาย'},{label:'นางสาว',value:'นางสาว'},{label:'นาง',value:'นาง'},{label:'ไม่ระบุ',value:'ไม่ระบุ'}]},
        gender: {'ui:field': EMSelect, 'options': [{label:'ชาย',value:'male'},{label:'หญิง',value:'female'}]},
        religion: {'ui:field': EMSelect, 'options': [{label:'พุทธ',value:'พุทธ'},{label:'คริสต์',value:'คริสต์'},{label:'อิสลาม',value:'อิสลาม'},{label:'คาทอลิค',value:'คาทอลิค'},{label:'ซิกข์',value:'ซิกข์'}]},
        marriage_status: {'ui:field': EMSelect, 'options': [{label:'โสด',value:'โสด'},{label:'สมรสจดทะเบียน',value:'สมรสจดทะเบียน'},{label:'สมรสไม่จดทะเบียน',value:'สมรสไม่จดทะเบียน'},{label:'หม้าย',value:'หม้าย'},{label:'หย่า',value:'หย่า'},{label:'แยกกันอยู่',value:'แยกกันอยู่'}]},
        height: {'ui:field': InputNumber, 'textAlign': 'center'},
        weight: {'ui:field': InputNumber, 'textAlign': 'center'},
        first_name: {'ui:field': EMInput},
        last_name: {'ui:field': EMInput},
        nick_name: {'ui:field': EMInput},
        mobile: {'ui:field': EMInput},
        address_registration: {'ui:field': EMInput},
        current_address: {'ui:field': EMInput},
        race: {'ui:field': EMInput},
        nationality: {'ui:field': EMInput},
        children: {'ui:field': EMInput}
    },
    group2: {
        'ui:field': LayoutField,
        'ui:layout': [        
            [
                {name: 'dob_date', props: {md: 6}},
                {name: 'id_card', props: {md: 6}}
            ],
            [    
                {name: 'ssn', props: {md: 6}},
                {name: 'no_taxpayer', props: {md: 6}}
            ],
            [
                {name: 'bank_name', props: {md: 6}},
                {name: 'bank_account', props: {md: 6}}
            ],
        ],
        dob_date: {'ui:field': EMDatePicker},
        id_card: {'ui:field': EMInput},
        ssn: {'ui:field': EMInput},
        no_taxpayer: {'ui:field': EMInput},
        bank_name: {'ui:field': EMInput},
        bank_account: {'ui:field': EMInput}
    },
    group3: {
        'ui:field': LayoutField,
        'ui:layout': [
            [
                {name: 'start_work_date', props: {md: 6}},
                {name: 'permanance_work_date', props: {md: 6}}
            ],
            [    
                {name: 'position', props: {md: 6}},
                {name: 'department', props: {md: 6}}
            ],
            [
                {name: 'work_status', props: {md: 6}},
                {name: 'slip_per_month', props: {md: 6}}
            ],
            [
                {name: 'exit_date', props: {md: 6}},
                {name: 'exit_reason', props: {md: 6}}
            ],
            [
                {name: 'exit_remark', props: {md: 12}}
            ]
        ],
        start_work_date: {'ui:field': EMDatePicker},
        permanance_work_date: {'ui:field': EMDatePicker},
        position: {'ui:field': EMInput},
        department: {'ui:field': EMInput},
        work_status: {'ui:field': EMInput},
        exit_date: {'ui:field': EMDatePicker},
        exit_reason: {'ui:field': EMSelect, options: [{label:'เลือกเหตุผล',value:''},{label:'ได้งานใหม่',value:'0'},{label:'ป่วย',value:'1'},{label:'ประกอบกิจการส่วนตัว',value:'2'},{label:'ไม่พอใจงานที่ทำ',value:'3'},{label:'ย้ายถิ่นฐาน',value:'4'},{label:'มีปัญหาในการทำงาน',value:'5'},{label:'หายตัวไปไม่ทราบสาเหตุ',value:'6'}]},
        exit_remark: {'ui:field': EMInput},
        slip_per_month: {'ui:field': EMRadio, 'title': true, 'options': [{label:'2 รอบ',value:'2'},{label:'เฉพาะสิ้นเดือน',value:'1'}]}
    },
    group4: {
        'ui:field': LayoutField,
        'ui:layout': [
            [
                {name: 'sick_quota', props: {md: 6}},
                {name: 'business_quota', props: {md: 6}}
            ]
        ],
        sick_quota: {'ui:field': InputNumber, 'textAlign': 'center'},
        business_quota: {'ui:field': InputNumber, 'textAlign': 'center'}
    },  
    group5: {
        'ui:field': LayoutField,
        'ui:layout': [  
            [
                {name: 'net_saving', props: {md: 6}}
            ]
        ],
        net_saving: {'ui:field': InputNumber, 'textAlign': 'center'}
    },
    group6: {
        'ui:field': LayoutField,
        'ui:layout': [
            [
                {name: 'perm_taking_car', props: {md: 2}},
                {name: 'perm_job_owner', props: {md: 2}},
                {name: 'perm_taking_stock', props: {md: 2}},
                {name: 'perm_fixing_car', props: {md: 2}},
                {name: 'perm_checking_car', props: {md: 2}}
            ]
        ],
        perm_taking_car: {'ui:field': EMCheckbox},
        perm_job_owner: {'ui:field': EMCheckbox},
        perm_taking_stock: {'ui:field': EMCheckbox},
        perm_fixing_car: {'ui:field': EMCheckbox},
        perm_checking_car: {'ui:field': EMCheckbox}
    }, 
    group7: {
        'ui:field': LayoutField,
        'ui:layout': [  
            [
                {name: 'slip_by', props: {md: 12}}
            ]
        ],
        slip_by: {'ui:field': EMRadio, 'title': false, 'options': [{label:'ผู้จัดการฝ่ายการเงิน',value:'md'},{label:'ฝ่ายบุคคล',value:'hr'}]}
    }        
}


// WEBPACK FOOTER //
// ./src/view/hr/employee/EmployeeEditGenFormSchema.js